export const SCROLL_PERCENTAGES_TO_SNAP = 1;
export const CONTAINER_WIDTH_ON_SCROLL = 100;

export const TABLE_HEADER_ELEMENT_HEIGHT = "64px";

export const CLASS_TABLE_CONTEXT_MENU_BUTTON = "table-context-menu-button";
export const TABLE_FIRST_COLUMN_WIDTH = ["229px", "229px", "351px", "520px"];
